import { EventController } from '../base';

export default class ModuleFormFieldsController extends EventController {
  static targets = ['subsourceSelect', 'supersourceSelect'];

  selectedSubsourceId?: number;
  subsourceSelectTarget: HTMLSelectElement;
  supersourceSelectTarget: HTMLSelectElement;

  connect() {
    const rawSubsourceId: string = this.data.get('selectedSubsourceId');
    this.selectedSubsourceId = rawSubsourceId ? parseInt(rawSubsourceId, 10) : null;
    this.loadSubsourceData(false);
  }

  loadSubsourceData(dispatchChangeEvent: boolean) {
    $(this.subsourceSelectTarget).empty();
    const supersourceId = this.getSelectedSupersourceId();
    if (!supersourceId) return;
    $.get(`/admin/api/supersource/${supersourceId}/subsources`, (optionList) => {
      $(this.subsourceSelectTarget).empty();
      for (let i = 0; i < optionList.length; i += 1) {
        const $option = $('<option></option>').attr('value', optionList[i].id).text(optionList[i].name);
        if (this.selectedSubsourceId === optionList[i].id) {
          $option.attr('selected', 'selected');
        }
        $(this.subsourceSelectTarget).append($option);
      }
      if (dispatchChangeEvent) this.dispatchSourcesChanged();
    });
  }

  onSelectSupersource = () => {
    this.loadSubsourceData(true);
  }

  onSelectSubsource = () => {
    this.dispatchSourcesChanged();
  }

  getSelectedSubsourceId() {
    const subsourceId: string = $(this.subsourceSelectTarget).val() as string;
    if (!subsourceId || subsourceId === '__None') return null;
    return parseInt(subsourceId, 10);
  }

  getSelectedSupersourceId() {
    const supersourceId = $(this.supersourceSelectTarget).val() as string;
    if (!supersourceId || supersourceId === '__None') return null;
    return parseInt(supersourceId, 10);
  }

  dispatchSourcesChanged() {
    this.dispatchNextTick(
      'SOURCES_CHANGED',
      this.getSelectedSupersourceId(),
      this.getSelectedSubsourceId(),
    );
  }
}
